// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-calendar {
  position: relative;
  display: inline-flex;
  width: 100%;
}
.p-calendar .p-inputtext {
  flex: 1 1 auto;
  width: 1%;
}
.p-calendar .p-datepicker-inline {
  min-width: 100%;
}
.p-calendar .p-datepicker:not(.p-datepicker-inline) table td {
  padding: 0.1rem;
}
.p-calendar .p-datepicker:not(.p-datepicker-inline) .p-datepicker-header {
  padding: 0.25rem;
}

.p-calendar-w-btn .p-inputtext {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.p-calendar-w-btn .p-datepicker-trigger {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.p-fluid .p-calendar {
  display: flex;
}
.p-fluid .p-calendar .p-inputtext {
  width: 1%;
}

.p-datepicker {
  width: auto;
  position: absolute;
  top: 0;
  left: 0;
}
.p-datepicker table {
  width: 100%;
  border-collapse: collapse;
}
.p-datepicker td > span {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
}

.p-datepicker-inline {
  display: inline-block;
  position: static;
  overflow-x: auto;
}

.p-datepicker-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.p-datepicker-header .p-datepicker-title {
  margin: 0 auto;
}

.p-datepicker-prev,
.p-datepicker-next {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
}

.p-datepicker-multiple-month .p-datepicker-group-container {
  display: flex;
  display: flex;
}
.p-datepicker-multiple-month .p-datepicker-group-container .p-datepicker-group {
  flex: 1 1 auto;
}

.p-monthpicker-month {
  width: 33.3%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  position: relative;
}

.p-datepicker-buttonbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.p-timepicker {
  display: flex;
  justify-content: center;
  align-items: center;
}
.p-timepicker button {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  position: relative;
}
.p-timepicker > div {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.p-datepicker-touch-ui,
.p-calendar .p-datepicker-touch-ui {
  position: fixed;
  top: 50%;
  left: 50%;
  min-width: 80vw;
  transform: translate(-50%, -50%);
}

.p-yearpicker-year {
  width: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  position: relative;
}

.p-calendar-clear-icon {
  position: absolute;
  top: 50%;
  right: 0.5rem;
  margin-top: -0.5rem;
  cursor: pointer;
}

.p-calendar-clearable {
  position: relative;
}

.label-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.gc-datepicker-label {
  display: inline;
}

:host.gc-datepicker.ng-dirty.ng-invalid .p-inputtext, :host.gc-datepicker.pristine-validate.ng-pristine.ng-invalid .p-inputtext {
  border-color: var(--gc-color-danger);
}

.p-datepicker-other-month .p-disabled {
  visibility: hidden;
}

tr.cw.p-highlight {
  background: rgb(var(--gc-color-primary-rgb));
  color: var(--gc-text-color-inverse);
}

.p-datepicker:not(.p-disabled) table tr.cw.p-highlight td span:not(.p-highlight):not(.p-disabled):hover {
  color: var(--gc-text-color);
}`, "",{"version":3,"sources":["webpack://./src/app/components/gc-datepicker/datepicker.component.sass"],"names":[],"mappings":"AAAA;EACC,kBAAA;EACA,oBAAA;EACA,WAAA;AACD;AAAC;EACC,cAAA;EACA,SAAA;AAEF;AADC;EACC,eAAA;AAGF;AADE;EACC,eAAA;AAGH;AAFE;EACC,gBAAA;AAIH;;AAFC;EACC,0BAAA;EACA,6BAAA;AAKF;AAJC;EACC,yBAAA;EACA,4BAAA;AAMF;;AAJC;EACC,aAAA;AAOF;AANE;EACC,SAAA;AAQH;;AAPA;EACC,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AAUD;AATC;EACC,WAAA;EACA,yBAAA;AAWF;AATE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAWH;;AAVA;EACC,qBAAA;EACA,gBAAA;EACA,gBAAA;AAaD;;AAZA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;AAeD;AAdC;EACC,cAAA;AAgBF;;AAfA;;EAEC,eAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAkBD;;AAhBC;EACC,aAAA;EACA,aAAA;AAmBF;AAlBE;EACC,cAAA;AAoBH;;AAnBA;EACC,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAsBD;;AArBA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAwBD;;AAvBA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;AA0BD;AAzBC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AA2BF;AA1BC;EACC,aAAA;EACA,mBAAA;EACA,sBAAA;AA4BF;;AA3BA;;EAEC,eAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,gCAAA;AA8BD;;AA7BA;EACC,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAgCD;;AA/BA;EACC,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAkCD;;AAjCA;EACC,kBAAA;AAoCD;;AAlCA;EACC,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAqCD;;AAnCA;EACC,eAAA;AAsCD;;AAlCE;EACC,oCAAA;AAqCH;;AAlCC;EACC,kBAAA;AAqCF;;AAnCA;EAEC,4CAAA;EACA,mCAAA;AAqCD;;AAnCA;EACC,2BAAA;AAsCD","sourcesContent":[".p-calendar \n\tposition: relative \n\tdisplay: inline-flex \n\twidth: 100% \n\t.p-inputtext \n\t\tflex: 1 1 auto \n\t\twidth: 1% \n\t.p-datepicker-inline\n\t\tmin-width: 100% \n\t.p-datepicker:not(.p-datepicker-inline) \n\t\ttable td\n\t\t\tpadding: 0.1rem\n\t\t.p-datepicker-header\n\t\t\tpadding: 0.25rem\n.p-calendar-w-btn \n\t.p-inputtext \n\t\tborder-top-right-radius: 0 \n\t\tborder-bottom-right-radius: 0 \n\t.p-datepicker-trigger \n\t\tborder-top-left-radius: 0 \n\t\tborder-bottom-left-radius: 0 \n.p-fluid \n\t.p-calendar \n\t\tdisplay: flex \n\t\t.p-inputtext \n\t\t\twidth: 1% \n.p-datepicker \n\twidth: auto \n\tposition: absolute \n\ttop: 0 \n\tleft: 0 \n\ttable \n\t\twidth: 100% \n\t\tborder-collapse: collapse \n\ttd \n\t\t& > span \n\t\t\tdisplay: flex \n\t\t\tjustify-content: center \n\t\t\talign-items: center \n\t\t\tcursor: pointer \n\t\t\tmargin: 0 auto \n\t\t\toverflow: hidden \n\t\t\tposition: relative \n.p-datepicker-inline \n\tdisplay: inline-block \n\tposition: static \n\toverflow-x: auto \n.p-datepicker-header \n\tdisplay: flex \n\talign-items: center \n\tjustify-content: space-between \n\t.p-datepicker-title \n\t\tmargin: 0 auto \n.p-datepicker-prev,\n.p-datepicker-next \n\tcursor: pointer \n\tdisplay: inline-flex \n\tjustify-content: center \n\talign-items: center \n\toverflow: hidden \n\tposition: relative \n.p-datepicker-multiple-month \n\t.p-datepicker-group-container \n\t\tdisplay: flex \n\t\tdisplay: flex \n\t\t.p-datepicker-group \n\t\t\tflex: 1 1 auto \n.p-monthpicker-month \n\twidth: 33.3% \n\tdisplay: inline-flex \n\talign-items: center \n\tjustify-content: center \n\tcursor: pointer \n\toverflow: hidden \n\tposition: relative \n.p-datepicker-buttonbar \n\tdisplay: flex \n\tjustify-content: space-between \n\talign-items: center \n.p-timepicker \n\tdisplay: flex \n\tjustify-content: center \n\talign-items: center \n\tbutton \n\t\tdisplay: flex \n\t\talign-items: center \n\t\tjustify-content: center \n\t\tcursor: pointer \n\t\toverflow: hidden \n\t\tposition: relative \n\t& > div \n\t\tdisplay: flex \n\t\talign-items: center \n\t\tflex-direction: column \n.p-datepicker-touch-ui,\n.p-calendar .p-datepicker-touch-ui \n\tposition: fixed \n\ttop: 50% \n\tleft: 50% \n\tmin-width: 80vw \n\ttransform: translate(-50%, -50%) \n.p-yearpicker-year \n\twidth: 50% \n\tdisplay: inline-flex \n\talign-items: center \n\tjustify-content: center \n\tcursor: pointer \n\toverflow: hidden \n\tposition: relative \n.p-calendar-clear-icon \n\tposition: absolute \n\ttop: 50% \n\tright: 0.5rem\n\tmargin-top: -.5rem \n\tcursor: pointer \n.p-calendar-clearable \n\tposition: relative \n\n.label-container\n\twidth: 100%\n\theight: 100%\n\tdisplay: flex\n\tjustify-content: center\n\talign-items: center\n\n.gc-datepicker-label\n\tdisplay: inline\n\n:host\n\t&.gc-datepicker.ng-dirty.ng-invalid, &.gc-datepicker.pristine-validate.ng-pristine.ng-invalid\n\t\t.p-inputtext\n\t\t\tborder-color: var(--gc-color-danger)\n\n.p-datepicker-other-month\n\t.p-disabled\n\t\tvisibility: hidden\n\ntr.cw.p-highlight\n\t// background: rgba(var(--gc-color-primary-rgb), 0.25)\n\tbackground: rgb(var(--gc-color-primary-rgb))\n\tcolor: var(--gc-text-color-inverse)\n\n.p-datepicker:not(.p-disabled) table tr.cw.p-highlight td span:not(.p-highlight):not(.p-disabled):hover\n\tcolor: var(--gc-text-color)"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
